import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import './rich-text-editor.scss';

/**
 * 富文本编辑器（ReactQuill），用于条款等内容。
 */
interface RichTextEditorProps {
    /** 当前 HTML 内容 */
    value: string;
    /** 内容变更回调 */
    onChange: (content: string) => void;
    /** 占位文案 */
    placeholder?: string;
    /** 是否只读 */
    readOnly?: boolean;
    /** 兼容旧版 RBP：多实例唯一 toolbar id（当前使用内置 toolbar，此参数忽略） */
    toolbarId?: string;
    /** 在父级为 flex 且限高时占满剩余高度（如大弹窗内） */
    fillHeight?: boolean;
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({
    value,
    onChange,
    placeholder = '',
    readOnly = false,
    fillHeight = false,
}) => {
    /** Quill 内置工具栏配置 */
    const modules = useMemo(
        () => ({
            toolbar: {
                container: [
                    [{ header: [1, 2, 3, false] }],
                    ['bold', 'italic', 'underline', 'strike'],
                    [{ list: 'ordered' }, { list: 'bullet' }],
                    ['link'],
                    [{ align: [] }],
                    [{ color: [] }, { background: [] }],
                    ['clean'],
                ],
            },
        }),
        [],
    );

    /** 允许的格式集合 */
    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'list', 'bullet',
        'link',
        'align',
        'color', 'background',
    ];

    return (
        <div
            className={['rich-text-editor-container', fillHeight ? 'rich-text-editor-container--fill' : '']
                .filter(Boolean)
                .join(' ')}
        >
            <ReactQuill
                theme="snow"
                value={value}
                onChange={onChange}
                modules={modules}
                formats={formats}
                placeholder={placeholder}
                readOnly={readOnly}
                className="rich-text-editor-container__quill"
            />
        </div>
    );
};

export default RichTextEditor;
